import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import ptBR from "element-plus/es/locale/lang/pt-br";
import i18n from "@/core/plugins/i18n";
import VueTheMask from "vue-the-mask";
import numeral from "numeral";
import utils from "@/utils";
import money from "v-money";
import Toast from "vue-toastification";
import ModalDrag from "@/core/plugins/modal-drag";
import "@/assets/css/main.css";
import VueShepherd from "vue-shepherd";
import Vue3Lottie from "vue3-lottie";

//imports for app initialization
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";

import CKEditor from "@ckeditor/ckeditor5-vue";
import "@ckeditor/ckeditor5-build-classic/build/translations/pt-br";

import setupInterceptors from "./services/SetupInterceptors";
setupInterceptors(store);

import "@/core/plugins/prismjs";
import "bootstrap";
import "vue-toastification/dist/index.css";

numeral.register("locale", "pt-br", {
  delimiters: {
    thousands: ".",
    decimal: ",",
  },
  currency: {
    symbol: "R$",
  },
});
numeral.locale("pt-br");

const app = createApp(App);

app.use(CKEditor);
app.use(store);
app.use(router);
// app.use(ElementPlus);
app.use(VueTheMask);
initApexCharts(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);
app.use(numeral);
app.use(money);
app.use(Toast);
app.directive("modal-drag", ModalDrag);
app.use(VueShepherd);
app.use(Vue3Lottie);

app.use(ElementPlus, {
  locale: ptBR,
});

app.config.globalProperties.$utils = utils;

app.mount("#app");
